// extracted by mini-css-extract-plugin
module.exports = {"list":"SubscriptionIncludes_list__OLDwx"};